// Libraries
var React = require('react');

// Styles
require('./Stats.scss');

class GoalkeeperStats extends React.Component {
    render() {
        return (
            <div className="Stats">
                {!isNaN(this.props.minutesPlayed) &&
                    <div className="Stats__item">
                        <p className="Stats__item--value">{this.props.minutesPlayed}</p>
                        <p className="Stats__item--heading">Minutes Played</p>
                    </div>
                }

                {!isNaN(this.props.goalsConceded) &&
                    <div className="Stats__item">
                        <p className="Stats__item--value">{this.props.goalsConceded}</p>
                        <p className="Stats__item--heading">Goals Conceded</p>
                    </div>
                }

                {!isNaN(this.props.saves) &&
                    <div className="Stats__item">
                        <p className="Stats__item--value">{this.props.saves}</p>
                        <p className="Stats__item--heading">Saves</p>
                    </div>
                }

                {!isNaN(this.props.throws) &&
                    <div className="Stats__item">
                        <p className="Stats__item--value">{this.props.totalThrows}</p>
                        <p className="Stats__item--heading">Throws</p>
                    </div>
                }

                {!isNaN(this.props.punches) &&
                    <div className="Stats__item">
                        <p className="Stats__item--value">{this.props.punches}</p>
                        <p className="Stats__item--heading">Punches</p>
                    </div>
                }

                {!isNaN(this.props.goalsScored) &&
                    <div className="Stats__item">
                        <p className="Stats__item--value">{this.props.goalKicks}</p>
                        <p className="Stats__item--heading">Goals Kicks</p>
                    </div>
                }

                {!isNaN(this.props.passAccuracy) &&
                    <div className="Stats__item">
                        <p className="Stats__item--value">{this.props.passAccuracy}%</p>
                        <p className="Stats__item--heading">Pass Accuracy</p>
                    </div>
                }

                {!isNaN(this.props.yellowCards) && !isNaN(this.props.redCards) &&
                    <div className="Stats__item">
                        <p className="Stats__item--value"><span className="yellowcard" aria-label="Number of yellow cards">{this.props.yellowCards}</span> <span className="redcard" aria-label="Number of red cards">{this.props.redCards}</span></p>
                        <p className="Stats__item--heading">Cards</p>
                    </div>
                }
            </div>
        )
    }
}

module.exports = GoalkeeperStats;



// WEBPACK FOOTER //
// ./src/components/LastFixturePlayerStats/GoalkeeperStats.js